// Comprehensive list of country dial codes for the phone selector
export const COUNTRY_CODES = [
  { code: "AE", dial: "+971", flag: "🇦🇪", name: "United Arab Emirates" },
  { code: "TR", dial: "+90", flag: "🇹🇷", name: "Turkey" },
  { code: "SA", dial: "+966", flag: "🇸🇦", name: "Saudi Arabia" },
  { code: "QA", dial: "+974", flag: "🇶🇦", name: "Qatar" },
  { code: "KW", dial: "+965", flag: "🇰🇼", name: "Kuwait" },
  { code: "BH", dial: "+973", flag: "🇧🇭", name: "Bahrain" },
  { code: "OM", dial: "+968", flag: "🇴🇲", name: "Oman" },
  { code: "GB", dial: "+44", flag: "🇬🇧", name: "United Kingdom" },
  { code: "US", dial: "+1", flag: "🇺🇸", name: "United States" },
  { code: "RU", dial: "+7", flag: "🇷🇺", name: "Russia" },
  { code: "DE", dial: "+49", flag: "🇩🇪", name: "Germany" },
  { code: "FR", dial: "+33", flag: "🇫🇷", name: "France" },
  { code: "IT", dial: "+39", flag: "🇮🇹", name: "Italy" },
  { code: "ES", dial: "+34", flag: "🇪🇸", name: "Spain" },
  { code: "NL", dial: "+31", flag: "🇳🇱", name: "Netherlands" },
  { code: "CH", dial: "+41", flag: "🇨🇭", name: "Switzerland" },
  { code: "BE", dial: "+32", flag: "🇧🇪", name: "Belgium" },
  { code: "AT", dial: "+43", flag: "🇦🇹", name: "Austria" },
  { code: "SE", dial: "+46", flag: "🇸🇪", name: "Sweden" },
  { code: "NO", dial: "+47", flag: "🇳🇴", name: "Norway" },
  { code: "DK", dial: "+45", flag: "🇩🇰", name: "Denmark" },
  { code: "FI", dial: "+358", flag: "🇫🇮", name: "Finland" },
  { code: "IE", dial: "+353", flag: "🇮🇪", name: "Ireland" },
  { code: "PT", dial: "+351", flag: "🇵🇹", name: "Portugal" },
  { code: "GR", dial: "+30", flag: "🇬🇷", name: "Greece" },
  { code: "PL", dial: "+48", flag: "🇵🇱", name: "Poland" },
  { code: "CZ", dial: "+420", flag: "🇨🇿", name: "Czechia" },
  { code: "RO", dial: "+40", flag: "🇷🇴", name: "Romania" },
  { code: "UA", dial: "+380", flag: "🇺🇦", name: "Ukraine" },
  { code: "HU", dial: "+36", flag: "🇭🇺", name: "Hungary" },
  { code: "BG", dial: "+359", flag: "🇧🇬", name: "Bulgaria" },
  { code: "HR", dial: "+385", flag: "🇭🇷", name: "Croatia" },
  { code: "RS", dial: "+381", flag: "🇷🇸", name: "Serbia" },
  { code: "AZ", dial: "+994", flag: "🇦🇿", name: "Azerbaijan" },
  { code: "GE", dial: "+995", flag: "🇬🇪", name: "Georgia" },
  { code: "KZ", dial: "+7", flag: "🇰🇿", name: "Kazakhstan" },
  { code: "IN", dial: "+91", flag: "🇮🇳", name: "India" },
  { code: "PK", dial: "+92", flag: "🇵🇰", name: "Pakistan" },
  { code: "BD", dial: "+880", flag: "🇧🇩", name: "Bangladesh" },
  { code: "CN", dial: "+86", flag: "🇨🇳", name: "China" },
  { code: "HK", dial: "+852", flag: "🇭🇰", name: "Hong Kong" },
  { code: "JP", dial: "+81", flag: "🇯🇵", name: "Japan" },
  { code: "KR", dial: "+82", flag: "🇰🇷", name: "South Korea" },
  { code: "SG", dial: "+65", flag: "🇸🇬", name: "Singapore" },
  { code: "MY", dial: "+60", flag: "🇲🇾", name: "Malaysia" },
  { code: "ID", dial: "+62", flag: "🇮🇩", name: "Indonesia" },
  { code: "TH", dial: "+66", flag: "🇹🇭", name: "Thailand" },
  { code: "PH", dial: "+63", flag: "🇵🇭", name: "Philippines" },
  { code: "VN", dial: "+84", flag: "🇻🇳", name: "Vietnam" },
  { code: "AU", dial: "+61", flag: "🇦🇺", name: "Australia" },
  { code: "NZ", dial: "+64", flag: "🇳🇿", name: "New Zealand" },
  { code: "CA", dial: "+1", flag: "🇨🇦", name: "Canada" },
  { code: "MX", dial: "+52", flag: "🇲🇽", name: "Mexico" },
  { code: "BR", dial: "+55", flag: "🇧🇷", name: "Brazil" },
  { code: "AR", dial: "+54", flag: "🇦🇷", name: "Argentina" },
  { code: "CL", dial: "+56", flag: "🇨🇱", name: "Chile" },
  { code: "CO", dial: "+57", flag: "🇨🇴", name: "Colombia" },
  { code: "EG", dial: "+20", flag: "🇪🇬", name: "Egypt" },
  { code: "MA", dial: "+212", flag: "🇲🇦", name: "Morocco" },
  { code: "DZ", dial: "+213", flag: "🇩🇿", name: "Algeria" },
  { code: "TN", dial: "+216", flag: "🇹🇳", name: "Tunisia" },
  { code: "LY", dial: "+218", flag: "🇱🇾", name: "Libya" },
  { code: "ZA", dial: "+27", flag: "🇿🇦", name: "South Africa" },
  { code: "NG", dial: "+234", flag: "🇳🇬", name: "Nigeria" },
  { code: "KE", dial: "+254", flag: "🇰🇪", name: "Kenya" },
  { code: "JO", dial: "+962", flag: "🇯🇴", name: "Jordan" },
  { code: "LB", dial: "+961", flag: "🇱🇧", name: "Lebanon" },
  { code: "IQ", dial: "+964", flag: "🇮🇶", name: "Iraq" },
  { code: "IR", dial: "+98", flag: "🇮🇷", name: "Iran" },
  { code: "IL", dial: "+972", flag: "🇮🇱", name: "Israel" },
  { code: "AF", dial: "+93", flag: "🇦🇫", name: "Afghanistan" },
  { code: "LK", dial: "+94", flag: "🇱🇰", name: "Sri Lanka" },
  { code: "NP", dial: "+977", flag: "🇳🇵", name: "Nepal" },
  { code: "AM", dial: "+374", flag: "🇦🇲", name: "Armenia" },
  { code: "BY", dial: "+375", flag: "🇧🇾", name: "Belarus" },
  { code: "SK", dial: "+421", flag: "🇸🇰", name: "Slovakia" },
  { code: "SI", dial: "+386", flag: "🇸🇮", name: "Slovenia" },
  { code: "LT", dial: "+370", flag: "🇱🇹", name: "Lithuania" },
  { code: "LV", dial: "+371", flag: "🇱🇻", name: "Latvia" },
  { code: "EE", dial: "+372", flag: "🇪🇪", name: "Estonia" },
  { code: "IS", dial: "+354", flag: "🇮🇸", name: "Iceland" },
  { code: "LU", dial: "+352", flag: "🇱🇺", name: "Luxembourg" },
  { code: "CY", dial: "+357", flag: "🇨🇾", name: "Cyprus" },
  { code: "MT", dial: "+356", flag: "🇲🇹", name: "Malta" },
];
